import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { VehiclesModel } from './vehicles.model';
import { Subject } from 'rxjs/Subject';
import { IJobsPortalVehicleLookupResponse } from '../../core/interfaces/jobs-portal-vehicle.interface';

@Injectable()
export class VehiclesService extends ParentService {

  private providerId = new BehaviorSubject<number>(null);
  providerId$ = this.providerId.asObservable();

  private vehicle = new BehaviorSubject<VehiclesModel>(null);
  vehicle$ = this.vehicle.asObservable();

  private vinValidity = new BehaviorSubject<boolean>(false);
  vinValidity$ = this.vinValidity.asObservable();

  private vinLookupEnabled = new BehaviorSubject<boolean>(false);
  vinLookupEnabled$ = this.vinLookupEnabled.asObservable();

  private vinLookupLoading = new BehaviorSubject<boolean>(false);
  vinLookupLoading$ = this.vinLookupLoading.asObservable();

  private vinLookupRequest = new Subject<void>();
  vinLookupRequest$ = this.vinLookupRequest.asObservable();

  private trips = new Subject<any[]>();
  trips$ = this.trips.asObservable();

  private emitReassigned = new Subject<boolean>();
  emitReassigned$ = this.emitReassigned.asObservable();

  smartTableData = [];
  comboPayorsData = [];

  constructor(
    private _http: Http,
    private route: Router,
  ) {
    super();
  }

  /**
   * @name getVehicles
   * @description
   * @param {nay} frmId
   * @param {nay} srchFrm
   * @param {boolean} shwDsbl
   * @param {boolean} ondemand
   * @param {nay} providerId
   * @param  {nay}vehicleCycleId
   */
  getVehicles(
    frmId: any,
    srchFrm: any,
    shwDsbl: boolean,
    ondemand?: boolean,
    providerId?: any,
    vehicleCycleId?: any
  ) {
    if ( frmId === 0 ) {
      return this._http
        .get(constant.URL_VEHICLE + '?showDisable=' + shwDsbl +
          '&code=' + srchFrm +
          '&ondemand=' + ondemand +
          '&providerId=' + providerId +
          '&vehicleCycleId=' + vehicleCycleId, this.getHeader())
        .map( res => res.json());
    }else {
      return this._http
        .get(constant.URL_VEHICLE + '/' + frmId, this.getHeader())
        .map( res => res.json());
    }
  }

  /**
   * @name getTimeNow
   * @description
   */
  getTimeNow() {
    return this._http
      .get(constant.URL_DATE_TIME_NOW, this.getHeader())
      .map( res => res.json());
  }

  sendToTrip2(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_SEND_VEHICLE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }


  /**
   * @name getVehiclesCycle
   * @description
   */
  getVehiclesCycle() {
    return this._http
      .get(constant.URL_VEHICLE_CYCLE, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getVehiclesTypeDoc
   * @description
   */
  getVehiclesTypeDoc() {
    return this._http
      .get(constant.URL_VEHICLE_TYPE_DOC, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getVehiclesLicense
   * @param vehicleid
   * @param isDisabled
   */
  getVehiclesLicense(vehicleid: number, isDisabled: boolean, showInactive: boolean = false) {
    const url = `${constant.URL_VEHICLE_LICENSE}/${vehicleid}/${isDisabled}?showInactive=${showInactive}`;
    return this._http
      .get(url, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getVehicleById
   * @param {number} id
   */
  getVehicleById(id: number) {
    return this._http
      .get(constant.URL_VEHICLE_GET_VEHICLE_BY_ID + '/' + id,  this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));

  }

  getVehicleInfo(id: number){
    return this._http
      .get(constant.URL_VEHICLE + '/' + id,  this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getVehicleByCompany
   * @description
   * @param companyId
   */
  getVehicleByCompany(companyId) {
    return this._http
      .get(constant.URL_VEHICLE + '/Company/' + companyId,  this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getVehicleByCompanyAndDepots
   * @description
   * @param providerid
   * @param depots
   */
  getVehicleByCompanyAndDepots(providerid, depotids = []) {
    const data = JSON.stringify({
      providerid,
      depotids
    });
    return this._http
      .post(constant.URL_VEHICLE + '/Company/', data, this.headerPost())
      .map(res => res.json())
      .catch(error => this.validate401Error(error, this.route));
  }

  /**
   * @name getVehicleColor
   * @description
   */
  getVehicleColor() {
    return this._http
      .get(constant.URL_VEHICLE_COLORS, this.getHeader())
      .map( res => res.json());
  }

  /**
   * @name getVehicleStatus
   * @description
   */
  getVehicleStatus() {
    return this._http
      .get(constant.URL_VEHICLE_STATUS, this.getHeader())
      .map( res => res.json());
  }

  /**
   * @name getCallType
   * @description
   */
  getCallType() {
    return this._http
      .get(constant.URL_CALL_TYPE, this.getHeader())
      .map( res => res.json());
  }

  /**
   * @name getVehiclePhotoType
   * @description
   */
  getVehiclePhotoType() {
    return this._http
      .get(constant.URL_VEHICLE_PHOTO_TYPE, this.getHeader())
      .map( res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getPhotoByVehicleId
   * @param vehicleId
   */
  getPhotoByVehicleId(vehicleId) {
    return this._http
      .get(constant.URL_PHOTO_BY_VEHICLE_ID + '/' + vehicleId, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getPhotoByVehicleId
   * @param vehicleId
   */
  getOnePhotoByVehicleId(vehicleId) {
    return this._http
      .get(constant.URL_VEHICLE_VEHICLE + '/' + vehicleId, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getVehiclesByDriver
   * @param driverid
   */
  getVehiclesByDriver(driverid, showInactive?: boolean) {
    return this._http
    .get(`${constant.URL_VEHICLE_BY_DRIVER}/${driverid}?showInactive=${showInactive ? showInactive : false}` , this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getT2Drivers
   * @description
   */
  getT2Drivers() {
    return this._http
      .get(constant.URL_TRIP2_DRIVER_ACTIVE, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getT2DriversAll
   * @description
   */
  getT2DriversAll() {
    return this._http
      .get(constant.URL_TRIP2_DRIVER_ALL, this.getHeader())
      .map( res => res.json());
  }

  /**
   * @name getDriverByVehicleBySchedule
   * @param vehicle
   * @param dateSchedule
   */
  getDriverByVehicleBySchedule(vehicle, dateSchedule) {
    return this._http
      .get(constant.URL_DRIVERS_BY_VEHICLE + vehicle + '/' + dateSchedule, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getInspections
   * @param id
   */
  public getInspections(id) {
    return this._http
      .get(constant.URL_GET_INSPECTIONS + id, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name postVehicleLicense
   * @param {any} data
   */
  postVehicleLicense(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_VEHICLE_LICENSE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putVehicleLicense
   * @description
   * @param {any} data
   */
  putVehicleLicense(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_VEHICLE_LICENSE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name postVehiclePhoto
   * @param {any} data
   */
  postVehiclePhoto(data: any) {
    const bodyString = JSON.stringify(data);
    const headers = new Headers({ 'Content-Type': 'application/json', 'Version': this.localVersion });
    const options = new RequestOptions({ headers: headers });

    return this._http
      .post(constant.URL_VEHICLE_PHOTO, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putVehiclePhoto
   * @param data
   * @param urlPhoto
   * @param vehiclePhotoId
   */
  putVehiclePhoto(data: any) {
    const bodyString = JSON.stringify(data);
    const headers = new Headers({ 'Content-Type': 'application/json', 'Version': this.localVersion });
    const options = new RequestOptions({ headers: headers });

    return this._http
      .put(constant.URL_VEHICLE_PHOTO, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name postData
   * @param {any} data
   */
  postData(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_VEHICLE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putData
   * @description
   * @param {any} data
   */
  putData(data: any) {

    delete data.company;
    delete data.driver;
    delete data.vehiclephotos;
    delete data.vehicletype;

    const bodyString = JSON.stringify(data);

    return this._http
      .put(constant.URL_VEHICLE, bodyString, this.headerPost())
      .map((res: Response) => res.json() )
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name deleteData
   * @param {any} data
   */
  deleteData(data: any) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'Version': this.localVersion });
    const options = new RequestOptions({ headers: headers });

    return this._http
      .delete(`${constant.URL_VEHICLE}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name assignDriver
   * @description
   * @param data
   */
  validateDriverTrips(data) {
    const url = `${constant.URL_VEHICLE}/ValidateDriverTrips`;
    return this._http
      .post(url, data, this.headerPost())
      .map((res: Response) => res.json() )
      .catch((error: any) => Observable.throw(error.json()));
  }


  assignDriver(data) {
    const url = `${constant.URL_VEHICLE}/AssignDriverToVehicle`;
    return this._http
      .post(url, data,  this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getAssignedVehicles
   * @description vehicle dispatch
   * @param companyIds
   * @param idate
   */
  getAssignedVehicles(companyIds, idate) {
    const data = {
        servicedate: idate,
        companyIds: companyIds,
        listtype: 'TripsToDispatch'
    };
    const bodyString = JSON.stringify(data);
    const url = constant.URL_TRIP_SEARCH + '/TripsByVehicles';
    return this._http
      .post(url, bodyString, this.headerPost())
      .map(resp => resp.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * this get all capacity types
   */
  getCapacityTypes() {
    return this._http
    .get(constant.URL_AUTO_ROUTING_CAPACITY_TYPES, this.getHeader())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.route));
  }

  /**
   * this get all capacity types
   */
  getCapacitiesByVehicle(vehicleid) {
    return this._http
    .get(constant.URL_AUTO_ROUTING_CAPACITIES_BY_VEHICLE + vehicleid, this.getHeader())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.route));
  }

  /**
   * this save capacity data into db
   * @param data data to save
   */
  saveCapacity(data: any) {
    const body = JSON.stringify(data);
    return this._http
      .post(constant.URL_CAPACITY, body, this.headerPost())
      .map((res: Response) => res.json())
      .catch(error => this.validate401Error(error, this.route));
  }

  /**
   * this update capacity data into db
   * @param data data to update
   */
  updateCapacity(data: any) {
    delete data.capacitytype;
    const body = JSON.stringify(data);
    return this._http
      .put(constant.URL_CAPACITY, body, this.headerPost())
      .map((res: Response) => res.json() )
      .catch(error => this.validate401Error(error, this.route));
  }
/**
 * this delete a capacity
 * @param capacityid capacity id to delete
 */
  deleteCapacity(capacityid) {
    return this._http
      .delete(`${constant.URL_CAPACITY}?vehiclecapacityid=${capacityid}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  getVehiclesByProviderByInactive(providerId: number, showInactive: boolean) {
    return this._http
      .get(constant.URL_VEHICLE + '/Units/' + providerId + '/' +showInactive,  this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getVehicleHistory
   * @param id = vehicleid
   */
  getVehicleHistory(id: number) {
    return this._http
      .get(`${constant.URL_VEHICLE}/${id}/History`,  this.getHeader())
      .map(res => res.json());

  }

  getVehicleInspection(vehicleid: number, startDate: string, endDate: string) {
    const url = `${constant.BASIC}VehicleInspection/filter/${startDate}/${endDate}/${vehicleid}`;
    return this._http
      .get(url, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  lookupVehicleByVin(vin: string): Observable<IJobsPortalVehicleLookupResponse> {
    return this._http
      .get(constant.URL_VEHICLE_VIN_LOOKUP + vin, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  checkVin(vin: string, vehicleId?: number): Observable<{ data: boolean }> {
    let url = constant.URL_VEHICLE_CHECK_VIN + vin;
    if (vehicleId) {
      url = url + '?excludeVehicleId=' + vehicleId;
    }
    return this._http
      .get(url, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  setProviderId(providerId: number): void {
    this.providerId.next(providerId);
  }

  setVehicleEditing(vehicle: VehiclesModel): void {
    this.vehicle.next(vehicle);
  }

  setVinValidity(isValid: boolean) {
    this.vinValidity.next(isValid);
  }

  setVinLookupEnabled(isEnabled: boolean): void {
    this.vinLookupEnabled.next(isEnabled);
  }

  setVinLookupLoading(isLoading: boolean): void {
    this.vinLookupLoading.next(isLoading);
  }

  requestVinLookup(): void {
    this.vinLookupRequest.next();
  }

  setTrips(trips: any[]) {
    this.trips.next(trips);
  }

  setEmitReassigned(value: boolean) {
    this.emitReassigned.next(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/vehicles/vehicles.service.ts